<div class="maintenance-notification" *ngIf="isVisible" [@sheetCollapse]="animationState">
  <div class="maintenance-notification__message" [internalInnerHtml]="message" [userEventSource]="userEventSource"></div>
  <div class="maintenance-notification__close" (click)="closeNotification()">
    <i class="icon icon-ui-close--sm"></i>
  </div>
</div>
